// GridInstant (03-dominio.md, RN47): the 5-minute grid of the times a correction can ask for. A time on the grid has seconds and
// milliseconds at 0 and minutes that are a multiple of 5 in LOCAL time (the user thinks in local time); the offset of the zone is
// taken at the instant itself, so the grid also holds the day of a clock change.

export const GRID_MS = 5 * 60 * 1000

const offsetAt = (ms) => -new Date(ms).getTimezoneOffset() * 60000

export const isOnGrid = (ms) => (ms + offsetAt(ms)) % GRID_MS === 0

/** The nearest instant of the grid (halves go up). */
export const snapToGrid = (ms) => {
  const offset = offsetAt(ms)
  return Math.round((ms + offset) / GRID_MS) * GRID_MS - offset
}

const floorToGrid = (ms) => {
  const offset = offsetAt(ms)
  return Math.floor((ms + offset) / GRID_MS) * GRID_MS - offset
}

const ceilToGrid = (ms) => {
  const offset = offsetAt(ms)
  return Math.ceil((ms + offset) / GRID_MS) * GRID_MS - offset
}

/** The first instant of the grid STRICTLY after `startMs`. */
export const firstInside = (startMs) => {
  let candidate = floorToGrid(startMs)
  while (candidate <= startMs) candidate += GRID_MS
  return candidate
}

/** The last instant of the grid STRICTLY before `endMs`. */
export const lastInside = (endMs) => {
  let candidate = ceilToGrid(endMs)
  while (candidate >= endMs) candidate -= GRID_MS
  return candidate
}

/** Whether some instant of the grid lies strictly inside (startMs, endMs). */
export const hasGridInside = (startMs, endMs) => firstInside(startMs) <= lastInside(endMs)

/** `ms` clamped to the first and last instants of the grid strictly inside (startMs, endMs). */
export const clampInside = (ms, startMs, endMs) => Math.min(lastInside(endMs), Math.max(firstInside(startMs), ms))

/** The previous (direction -1) or next (+1) instant of the grid from `ms`, `steps` grid steps away. */
export const stepOnGrid = (ms, direction, steps = 1) => {
  const base = isOnGrid(ms) ? ms : (direction < 0 ? ceilToGrid(ms) : floorToGrid(ms))
  return base + direction * steps * GRID_MS
}
